import { render, staticRenderFns } from "./majorDomoList.vue?vue&type=template&id=ebfd7b0e&scoped=true&"
import script from "./majorDomoList.vue?vue&type=script&lang=js&"
export * from "./majorDomoList.vue?vue&type=script&lang=js&"
import style0 from "./majorDomoList.vue?vue&type=style&index=0&id=ebfd7b0e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfd7b0e",
  null
  
)

export default component.exports